import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import {
  OrganizationService,
  PdfViewerService,
  TaskService,
} from '../../services';
import { request } from 'http';
import { tap } from 'rxjs/operators';
import { AppFilter } from '@app/shared/models';
import { environment } from 'src/environments/environment';
import {
  RegistrationDetailsVerifyModal,
  RegistrationDetailsViewModal,
} from '../../modals';
import { ConfirmModal } from '@app/shared/modals';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { DashboardProvider } from 'src/modules/features/contractor/services';

interface IFieldChangeModalContext {
  data: any;
  title?: string;
}
@Component({
  selector: 'app-field-registration-details',
  templateUrl: './registration-details-modal.html',
  styleUrls: ['./registration-details-modal.scss'],
})
export class RegistrationDetailsModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  baseUrl: string = environment.API_SERVER;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  toggleButton: boolean = false;
  roleForm: FormGroup;
  audit;
  request;
  filter: AppFilter;
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  searchFilter = {};
  maxSize: number = 7;
  history;
  toValue;
  type;
  open: boolean = false;
  countries;
  organization;
  states;
  origin;
  nationality;
  documentsType;
  documentType;
  fromValue;
  shareholder = [];
  allAffiliateTypeNames = [];
  pendingArr: boolean[] = [];
  allStatus: any;
  personnelStructures: any[] = [];
  organizationId: string = '';
  groupedDocuments: any[] = [];
  companyOrganization;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IFieldChangeModalContext, void, void>,
    private taskService: TaskService,
    private modalService: SuiModalService,
    private organizationSvc: OrganizationService,
    private companyOwnershipService: CompanyOwnershipService,
    private dashboardSvc: DashboardProvider,
    private pdfViewerService: PdfViewerService
  ) {
    this.request = modal.context.data;
    this.organizationId =
      this.request.changeRequest.organization.organizationId;
    this.companyOrganization =
      this.request.changeRequest.organization.jpaContractor;
    this.type = this.request.changeRequestType;
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.getAllAffiliateTypeNames();

    // this.getCountryOrigin(this.toValue);

    // this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
    // this.getPage(1);
    // this.getDocuments();
  }
  verifyTask: boolean = false;
  canVerifyTask() {
    this.pending = true;
    this.taskService
      .checkUserVerify({
        approvalMonitoringId: this.request.approvalMonitoringId,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.verifyTask = res.canVerify;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  isFieldValid(field: string) {
    return (
      (!this.roleForm.get(field).valid && this.roleForm.get(field).touched) ||
      (this.roleForm.get(field).untouched && this.formSubmitAttempt)
    );
  }
  getOptionTypes(data) {
    let filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10000,
      sord: 'desc',
    });
    this.organizationSvc.getDocumentType({ params: filter }).subscribe(
      (res: any) => {
        // this.optionLoading = false;
        this.documentsType = res['rows'];
        let result = this.documentsType.filter((item) => {
          return item.documentTypeId === data;
        });
        this.documentType = result[0]?.documentTypeName;
      },
      (error) => {}
    );
  }

  getCountry(data) {
    let result = this.origin.filter((item) => {
      return item.countryCode === data.countryOfRegistration;
    });
    this.countries = result[0];
  }
  /**
   * @author Praise
   * @dateCreated 08 Aug 2023
   * @description The function checks if the fromvalue or tovalue is an array.
   * @param data - an array of objects or string.

   * @returns A boolean of true or false.
   * @dependencies None
   * @modifiedBy
   * @dateModified
   * @reasonForModification
   */

  checkIfArray(data) {
    if (data) {
      return Array.isArray(data);
    }
  }
  viewDocument(data) {
    this.pdfViewerService.viewPdf(data);
  }
  getCountryOrigin(data) {
    this.organizationSvc.getCountries({}).subscribe((res) => {
      this.origin = res['rows'];
      this.fromValue = JSON.parse(this.request.changeRequest.fromValue);
      if (this.personnelStructures.includes(this.request.changeRequestType)) {
        this.toValue = JSON.parse(
          this.request.changeRequest.changes
            ? this.request.changeRequest.changes
            : this.request.changeRequest.toValue
        );
      } else {
        this.toValue = JSON.parse(this.request.changeRequest.toValue);
      }

      let filter;
      if (this.type === 'DIRECTORS_STRUCTURE') {
        filter = 'DIRECTOR_STRUCTURE';
      } else {
        filter = this.type;
      }
      if (this.personnelStructures.includes(this.request.changeRequestType)) {
        this.toValue = JSON.parse(
          this.request.changeRequest.changes
            ? this.request.changeRequest.changes
            : this.request.changeRequest.toValue
        );
      } else {
        this.toValue = JSON.parse(this.request.changeRequest.toValue);
      }
      if (
        // this.request.changeRequestType == 'DIRECTOR_STRUCTURE' ||
        // this.request.changeRequestType == 'SHAREHOLDER_STRUCTURE'
        this.personnelStructures.includes(this.request.changeRequestType)
      ) {
        this.fromValue = JSON.parse(this.request.changeRequest.fromValue);

        // this.fromValue = this.fromValue.filter((item) => {
        //   if (item.ownershipTypeIdName) {
        //     const keys = item.ownershipTypeIdName
        //       .map((obj) => Object.keys(obj))
        //       .flat();
        //     if (keys.includes(filter.toLowerCase().split('_')[0] + '_type')) {
        //       return item;
        //     }
        //   }
        // });
        let seen2 = new Set();
        this.fromValue = this.fromValue.filter((obj) => {
          if (obj.actionType === 'ADD') {
            return true;
          } else if (seen2.has(obj.organizationOwnershipId)) {
            return false;
          } else {
            seen2.add(obj.organizationOwnershipId);
            return true;
          }
        });
        this.toValue.map((item) => {
          this.shareholder.push(item);
        });
        this.fromValue.map((item) => {
          if (item.actionType) {
          } else {
            this.shareholder.push(item);
          }
        });
        this.toValue.map((item) => {
          if (item.actionType === 'NONE') {
            this.fromValue.push(item);
          } else if (item.actionType) {
          } else {
            this.fromValue.push(item);
          }
        });
        const seenNationalIds = new Set();
        this.fromValue = this.fromValue.filter((item) => {
          if (!seenNationalIds.has(item.nationalIdNumber)) {
            seenNationalIds.add(item.nationalIdNumber);
            return true;
          }
          return false;
        });
        let seen = new Set();
        this.shareholder = this.shareholder.filter((obj) => {
          if (obj.actionType === 'ADD') {
            return true;
          } else if (seen.has(obj.organizationOwnershipId)) {
            return false; // Remove object if the organizationOwnershipId  has already been seen
          } else {
            seen.add(obj.organizationOwnershipId);
            return true; // Keep object if the organizationOwnershipId  has not been seen
          }
        });
      }

      if (this.request.changeRequestType === 'OFFICIAL_DOCUMENT') {
        this.getOptionTypes(this.toValue.documentTypeId);
      }
      if (this.request.changeRequestType === 'ADDRESS') {
        this.getCountry(this.toValue);
        this.getStates(this.toValue);
      }
      if (this.toValue.organizationOwnershipTypeId) {
        delete this.toValue.organizationOwnershipTypeId;
      }
      if (this.toValue.organizationId === '') {
        delete this.toValue.organizationId;
      }
      if (
        this.toValue.organizationOwnershipId ||
        this.toValue.organizationOwnershipId === ''
      ) {
        delete this.toValue.organizationOwnershipId;
      }
      if (this.personnelStructures.includes(this.request.changeRequestType)) {
        this.documents = this.toValue[0].documents;
      } else {
        if (this.toValue.documents) {
          this.documents = this.toValue.documents;
        } else if (this.toValue.document) {
          this.documents = [this.toValue.document];
        } else {
          this.documents = [];
        }
      }
      if (this.documents && this.documents.length > 0) {
        this.groupData(this.documents);
      } else {
        this.getDocuments();
      }
    });
  }
  downloadDocumentGroupData(data) {
    const groupedObjects = data.reduce((result, obj) => {
      const key = obj.documentTypeName;
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(obj);
      return result;
    }, {});
    this.groupedDocuments = Object.entries(groupedObjects).map(
      ([key, value]) => ({ key, value })
    );
  }
  dataSource = [
    { name: 'John', age: 30 },
    { name: 'Jane', age: 25 },
    { name: 'Doe', age: 40 },
  ];
  groupData(data) {
    data.map((item) => {
      if (!item.documentTypeId.documentTypeName) {
        item.documentTypeId.documentTypeName = item.documentName;
      }
    });
    const groupedObjects = data.reduce((result, obj) => {
      const key = obj.documentTypeId.documentTypeId
        ? obj.documentTypeId.documentTypeName
        : obj.documentTypeName;
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(obj);
      return result;
    }, {});
    this.groupedDocuments = Object.entries(groupedObjects).map(
      ([key, value]) => ({ key, value })
    );
  }
  filterEquip(data) {
    // organizationId;
    if (data.key === 'equipTypeId') {
      return data.value.replaceAll('_', ' ');
    } else if (data.key === 'organizationId') {
      delete data.value;
    } else {
      return data.value;
    }
  }
  getCountryNational(data) {
    this.organizationSvc
      .getCountries({ organizationId: this.organization.organizationId })
      .subscribe((res) => {
        this.nationality = res['rows'];
        this.nationality = this.nationality.filter((item) => {
          return item.countryCode === data.nationalityId;
        });
        this.nationality = this.nationality[0];
      });
  }
  getStates(data) {
    this.organizationSvc.getStates({ filter: '' }).subscribe((res) => {
      this.states = res['rows'];
    });
  }
  showValue(data) {
    if (data.key === 'countryOfRegistration') {
      let result = this.origin?.filter((item) => {
        return item.countryCode === data.value;
      });
      if (result) {
        return result[0]?.countryName;
      }
    } else if (
      data.key === 'headOfficeAddressState' ||
      data.key === 'headOfficeAddressStateId'
    ) {
      let result = this.states?.filter((item) => {
        return item.stateId === data.value;
      });
      if (result) {
        return result[0]?.stateName;
      }
    } else if (data.key === 'documents') {
      return '';
    } else {
      return data.value;
    }
  }
  showValueDirector(data) {
    if (data.key === 'countryOfOriginId') {
      return this.filterResult(data.value);
    } else if (data.key === 'nationalityId') {
      return this.filterResult(data.value);
    } else if (data.key === 'organizationOwnershipId') {
      return '';
    } else if (data.key === 'organizationOwnershipTypeId') {
      return '';
    } else if (data.key === 'actionType') {
      return '';
    } else if (data.key === 'photographDocumentId') {
      return '';
    } else if (data.key === 'photographDocumentPath') {
      return '';
    } else if (
      data.key === 'shareholding' &&
      this.type !== 'SHAREHOLDER_STRUCTURE'
    ) {
      return '';
    } else if (data.key === 'ownershipTypeName') {
      return '';
    } else if (data.key === 'share') {
      return '';
    } else if (data.key === 'ownershipTypeIdName') {
      return '';
    } else if (data.key === 'documents') {
      return '';
    } else if (data.key === 'shareholderType') {
      return '';
    } else if (data.key === 'createdBy') {
      return '';
    } else if (data.key === 'dateCreated') {
      return '';
    } else if (data.key === 'modifiedBy') {
      return '';
    } else if (data.key === 'dateModified') {
      return '';
    } else if (data.key === 'organizationId') {
      return '';
    } else if (data.key === 'deleted') {
      return '';
    } else if (data.key === 'countryOfOriginName') {
      return '';
    } else if (data.key === 'nationalityName') {
      return '';
    } else if (data.key === 'companyName' && data.value === 'null') {
      return '';
    } else if (data.key === 'companyRegNumber' && data.value === 'null') {
      return '';
    } else {
      return data.value;
    }
  }

  filterResult(data) {
    let result = this.origin.filter((item) => {
      return item.countryCode === data;
    });
    return result[0]?.countryName;
  }

  rename(data) {
    if (data === 'companyType') {
      return 'COMPANY TYPE';
    } else if (data === 'dateOfRegistration') {
      return 'DATE OF REGISTRATION';
    } else if (data === 'ownershipType') {
      return 'OWNERSHIP TYPE';
    } else if (data === 'rcNumber') {
      return 'RC NUMBER';
    }
  }
  value(data) {
    if (data.key === 'companyType') {
      return data.value.split('_actual')[0].replaceAll('_', ' ');
    } else if (data.key === 'dateOfRegistration') {
      return data.value;
    } else if (data.key === 'ownershipType') {
      return data.value.replaceAll('_', ' ');
    } else if (data.key === 'rcNumber') {
      return data.value;
    }
  }
  equipmentValue(data) {
    if (data === 'equipModelNumber') {
      return 'EQUIPMENT MODEL NUMBER';
    } else if (data === 'equipName') {
      return 'EQUIPMENT NAME';
    } else if (data === 'equipTypeId') {
      return 'EQUIPMENT TYPE';
    } else if (data === 'yearOfManufacture') {
      return 'YEAR OF MANUFACTURE';
    } else if (data === 'manufacturerName') {
      return 'MANUFACTURER NAME';
    }
  }

  addressValue(data) {
    if (data === 'countryOfRegistration') {
      return 'COUNTRY';
    } else if (
      data === 'headOfficeAddressState' ||
      data === 'headOfficeAddressStateId'
    ) {
      return 'STATE';
    } else if (data === 'headOfficeAddressCity') {
      return 'CITY';
    } else if (data === 'headOfficeAddressStreet') {
      return 'STREET';
    } else if (data === 'headOfficeAddressZip') {
      return 'ZIP';
    }
  }
  directorValue(data) {
    if (data === 'countryOfOriginId') {
      return 'COUNTRY OF ORIGIN';
    } else if (data === 'firstName') {
      return 'FIRST NAME';
    } else if (data === 'gender') {
      return 'GENDER';
    } else if (data === 'lastName') {
      return 'LAST NAME';
    } else if (data === 'middleName') {
      return 'MIDDLE NAME';
    } else if (data === 'nationalIdNumber') {
      return 'NATIONAL ID NUMBER';
    } else if (data === 'nationalityId') {
      return 'NATIONALITY';
    } else if (data === 'shareholding') {
      return '';
    } else if (data === 'organizationOwnershipId') {
      return '';
    } else if (data === 'organizationOwnershipTypeId') {
      return '';
    } else if (data.key === 'actionType') {
      return '';
    }
  }
  returnPercent(data) {
    if (data) {
      return `${data}%`;
    } else if (data === 0) {
      return '0%';
    }
  }
  shareHolderValue(data, exist, fullData) {
    if (data === 'countryOfOriginId') {
      return 'COUNTRY OF ORIGIN';
    } else if (data === 'firstName') {
      return 'FIRST NAME';
    } else if (data === 'gender') {
      return 'GENDER';
    } else if (data === 'lastName') {
      return 'LAST NAME';
    } else if (data === 'middleName') {
      return 'MIDDLE NAME';
    } else if (data === 'nationalIdNumber') {
      return 'NATIONAL ID NUMBER';
    } else if (data === 'nationalityId') {
      return 'NATIONALITY';
    } else if (data === 'address') {
      return 'ADDRESS';
    } else if (data === 'email') {
      return 'EMAIL ADDRESS';
    } else if (
      data === 'shareholding' &&
      this.type === 'SHAREHOLDER_STRUCTURE'
    ) {
      return 'SHAREHOLDING AMOUNT';
    } else if (data === 'ownershipTypeName') {
      return '';
    } else if (data === 'ownershipTypeIdName') {
      return '';
    } else if (data === 'phoneNumber') {
      return 'PHONE NUMBER';
    } else if (data === 'organizationOwnershipId') {
      return '';
    } else if (data === 'organizationOwnershipTypeId') {
      return '';
    } else if (data === 'companyName' && exist && fullData.value !== 'null') {
      return 'Company Name';
    } else if (
      data === 'companyRegNumber' &&
      exist &&
      fullData.value !== 'null'
    ) {
      return 'Company Registration Name';
    } else if (data === 'actionType') {
      return '';
    } else if (data === 'photographDOcumentId') {
      return '';
    } else if (data === 'share') {
      return '';
    } else if (data === 'createdBy') {
      return '';
    } else if (data === 'dateCreated') {
      return '';
    } else if (data === 'modifiedBy') {
      return '';
    } else if (data === 'dateModified') {
      return '';
    } else if (data === 'organizationId') {
      return '';
    } else if (data === 'deleted') {
      return '';
    } else if (data === 'countryOfOriginName') {
      return '';
    } else if (data === 'nationalityName') {
      return '';
    }
  }

  contactValue(data) {
    if (data === 'companyContactAlternativeEmail') {
      return 'ALTERNATIVE EMAIL';
    } else if (data === 'companyContactEmail') {
      return 'EMAIL';
    } else if (data === 'companyContactPhone1') {
      return 'PHONE NUMBER';
    } else if (data === 'website') {
      return 'WEBSITE';
    }
  }
  changeToggle(data) {
    if (data === 'history') {
      this.toggleButton = true;
    } else if (data === 'request') {
      this.toggleButton = false;
    }
  }
  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  getPage(page) {
    this.pending = true;
    (this.filter['organizationId'] =
      this.request.workflowGroups?.collaboratorId.collaboratorId),
      this.taskService
        .getRequestHistory({
          params: this.filter,
          changeRequestType: this.request.changeRequestType,
        })
        .pipe(
          tap((res) => {
            this.totalItems = +res['records'];
            this.currentPage = page;
            this.rows = this.filter.rows;
          })
        )
        .subscribe(
          (res) => {
            this.pending = false;
            this.history = res['rows'];
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
  }
  documents;
  getDocuments() {
    this.pending = true;
    this.taskService
      .getRequestDocument({
        changeRequestType: this.request.changeRequest.changeRequestId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.documents = res;
          this.downloadDocumentGroupData(this.documents);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  save() {
    this.pending = true;
    let body = {
      approvalMonitoringId: this.request.approvalMonitoringId,
      status: 'REJECTED',
      remark: 'string',
    };
    this.taskService.acceptOrRejectUpdate({ body: body }).subscribe(
      (res) => {
        this.pending = false;
        // this.data = res;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }
  verifyDetails(data) {
    this.modalService
      .open(
        new RegistrationDetailsVerifyModal(
          'Verify Company Registration Details',
          {
            ...data,
            personnelStructures: this.personnelStructures,
            organizationId: this.organizationId,
          },
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {
        this.modal.approve(null);
      })
      .onDeny(() => {
        if (
          this.personnelStructures.includes(this.request.changeRequestType) &&
          this.request.status === 'PENDING'
        ) {
          this.modal.approve(null);
        }
      });
  }
  viewDetails(data) {
    this.modalService
      .open(
        new RegistrationDetailsViewModal(
          'View Company Registration Details',
          {
            ...data,
            personnelStructures: this.personnelStructures,
            organizationId: this.organizationId,
          },
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {
        this.modal.approve(null);
      })
      .onDeny(() => {});
  }
  verify(data, type) {
    this.modalService
      .open(
        new ConfirmModal(
          `Proceed to Verify or Decline?`,
          `Are you sure you want to proceed?`,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        if (type === 'Verify') {
          this.verifyDetails(data);
        }
      })
      .onDeny(() => {});
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  getAllAffiliateTypeNames() {
    this.pendingArr.push(true);
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypeNames = res.map((elem) =>
          elem.optionName.toUpperCase()
        );
        this.pendingArr.pop();
        this.getVerificationStatus();
      },
      (err: any) => {
        this.pendingArr.pop();
      }
    );
  }

  getVerificationStatus() {
    this.pendingArr.push(true);
    this.dashboardSvc
      .getStatus({
        organizationId: this.organizationId,
      })
      .subscribe(
        (res) => {
          this.pendingArr.pop();
          this.allStatus = res;
          this.getPersonnelStructureTypes();
        },
        (error) => {
          this.pendingArr.pop();
          this.getPersonnelStructureTypes();
          // this.error = error.error.errorMessage
          //   ? error.error.errorMessage
          //   : error.error
          //   ? error.error
          //   : error;
        }
      );
  }

  getPersonnelStructureTypes() {
    if (this.allStatus && this.allAffiliateTypeNames.length) {
      let statusKeys = Object.keys(this.allStatus);
      statusKeys = statusKeys.map((key) => key.toUpperCase());
      this.allAffiliateTypeNames.forEach((affiliateType) => {
        statusKeys.every((key) => {
          if (key.includes(affiliateType)) {
            this.personnelStructures.push(key);
            return false;
          }
          return true;
        });
      });
      if (
        this.personnelStructures.includes(this.request.changeRequestType) &&
        this.request.status === 'PENDING'
      ) {
        this.verifyDetails(this.request);
      }
      this.getCountryOrigin(this.toValue);
      this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
      this.getPage(1);
      // this.getDocuments();
    } else {
      this.getCountryOrigin(this.toValue);
      this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
      this.getPage(1);
    }
  }

  getType(type: string) {
    return type.replace(/_.*/g, '');
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
  getName() {
    if (this.personnelStructures.includes(this.type)) {
      if (this.request.status === 'APPROVED') {
        return `CURRENT ${this.type.split('_')[0]} RECORDS`;
      } else if (this.request.status === 'DISCARDED') {
        return `DISCARDED ${this.type.split('_')[0]} RECORDS`;
      } else {
        return `REJECTED ${this.type.split('_')[0]} RECORDS`;
      }
    } else {
      if (this.request.status === 'APPROVED') {
        return 'ACCEPTED RECORDS';
      } else if (this.request.status === 'DISCARDED') {
        return 'DISCARDED RECORDS';
      } else {
        return 'REJECTED RECORDS';
      }
    }
  }
}

export class RegistrationDetailsModal extends ComponentModalConfig<
  IFieldChangeModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(RegistrationDetailsModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
